var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{attrs:{"direction":"vertical"}},[_c('navbar',{attrs:{"hide":true}}),_c('form-success'),_c('site-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }